const WebsocketConfigClient = (() => {
  // Instance stores a reference to the singleton
  let instance;

  const init = (options) => {
    // Private methods and variables
    const defaults = {
      url: 'ws://127.0.0.1:12212/configs',
      onConnect: function () {},
      onDisconnect: function () {},
      onUpdate: function () {},
      onSend: function () {},
      autoReconnect: true,
      maxRetryCount: 30,
    };

    let settings = { ...defaults, ...options };
    let websocket = null;
    let connected = false;
    let retryCount = 0;

    const onMessage = (evt) => {
      try {
        let parsedData = JSON.parse(evt.data);
        settings.onUpdate(parsedData);
      } catch (e) {
        console.error(e);
      }
    };

    const onConnect = () => {
      connected = true;
      websocket.send('GET-CONFIG');
      settings.onConnect();
    };

    const onDisconnect = () => {
      connected = false;
      settings.onDisconnect();
      websocket = null;
      if (settings?.autoReconnect && retryCount < defaults.maxRetryCount) {
        retryCount += 1;
        reconnect();
      }
    };

    const connect = () => {
      if (websocket === null) {
        websocket = new WebSocket(settings.url);
        websocket.onopen = onConnect;
        websocket.onclose = onDisconnect;
        websocket.onmessage = onMessage;
      }
    };

    const reconnect = () => {
      connect();
    };

    // Start connect websocket
    connect();

    return {
      // Public methods and variables
      config: (options) => {
        settings = { ...settings, ...options };
      },
      connect: () => {
        connect();
      },
      getConfig: () => {
        websocket.send('GET-CONFIG');
        if (settings?.onSend) {
          settings?.onSend();
        }
      },
      close: () => {
        if (!websocket) return;
        websocket.close();
        websocket = null;
      },
      isConnected: () => {
        return connected;
      },
    };
  };

  return {
    // Get the singleton instance if one exists
    // or create one if it doesn't
    getInstance: (options) => {
      if (!instance) {
        instance = init(options);
      }

      return instance;
    },
  };
})();

const wsConfigClient = WebsocketConfigClient.getInstance();

export default wsConfigClient;
